import {Fragment} from 'react'
import {FormProvider} from 'react-hook-form'
import {Map} from 'immutable'
import PropTypes from 'prop-types'
import QRCode from 'react-qr-code'

import IconButton from '@mui/material/IconButton'

import {Box} from '../../../../../dashboard/src/components/blocks/Boxes'
import {ContentBox, ContentBoxGutterMedium} from '../../../../../dashboard/src/components/blocks/ContentBoxes'
import OtpInput from '../../../../../shared_components/forms/v3/OtpInput'
import {Text} from '../../../../../dashboard/src/components/blocks/Texts'
import UnorderedList from '../../../../../shared_components/UnorderedList'
import {parseProvisioningUri} from '../../../../../lib/tfaTools'
import {QuestionMarkIcon} from '../tfa_setup/QuestionMarkIcon'

import copyIcon from '../../../../../shared_assets/copyIcon.png'

const SetupAppEnrollment = props => {
  const {methods, appEnrollment, handleSubmit, copySecret} = props
  const provisioningUri = parseProvisioningUri(appEnrollment.get('provisioning-uri', ''))

  return (
    <Fragment>
      {
        props.appEnrollment.get('provisioning-uri', '') && (
          <Fragment>
            <ContentBoxGutterMedium className='authenticator-setup body flex-container'>
              <ContentBox className='instructions'>
                <h4>Scan QR code</h4>
                <UnorderedList children={['Open your authenticator app', 'Tap "add account" or the + icon', 'Scan this QR code']} />
                <ContentBox className='prompt-container'>
                  <QuestionMarkIcon className='prompt-icon' />
                  <ContentBox className='prompt'>
                    <span className='question'>Don't have an authenticator app?</span>{' '}
                    Download one of the following recommended apps from your
                    device's App Store:{' '}
                    <strong>Google Authenticator, Authy, 1Password</strong>
                  </ContentBox>
                </ContentBox>
              </ContentBox>
              <Box className='qr-code'>
                <QRCode
                  size={256}
                  style={{height: 'auto', maxWidth: '100%', width: '100%'}}
                  value={props.appEnrollment.get('provisioning-uri', '')}
                  viewBox='0 0 256 256'
                />
              </Box>
            </ContentBoxGutterMedium>
            <ContentBoxGutterMedium className='alternate-setup flex-container'>
              <ContentBoxGutterMedium className='instructions'>
                <h4>Or enter setup key manually</h4>
                <Text>if you can't scan the QR code, enter this key in your authenticator app:</Text>
              </ContentBoxGutterMedium>
              <ContentBox className='setup-secret flex-container'>
                <Text className='secret-code'>{provisioningUri.searchParams.get('secret')}</Text>
                <IconButton onClick={copySecret}>
                  <img alt='copy-icon' src={copyIcon} />
                </IconButton>
              </ContentBox>
            </ContentBoxGutterMedium>
          </Fragment>
        )
      }
      <ContentBox className='confirm-code flex-container'>
        <h4>Verification code</h4>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(handleSubmit)}>
            <OtpInput className='otp-input' name='code' control={methods.control} error={props.error} />
            <input type='submit' hidden />
          </form>
        </FormProvider>
      </ContentBox>
    </Fragment>
  )
}

SetupAppEnrollment.propTypes = {
  appEnrollment: PropTypes.instanceOf(Map).isRequired,
  error: PropTypes.string,
  methods: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  copySecret: PropTypes.func.isRequired,
  goToConfirmCode: PropTypes.func.isRequired
}

export default SetupAppEnrollment
